export { default } from './WindStationCardPlaceholders';
